import React, { useCallback } from 'react';
import { styled } from '@linaria/react';
import { useDispatchTeamEvent } from '@daedalus/core/src/analytics/components/TeamContext';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
export enum SelectedElementType {
  Rating = 'rating',
  Sentiment = 'sentiment',
  GuestTypesHeader = 'guestTypesHeader',
  GuestType = 'guestType',
  RatingHeader = 'guestRatingHeader',
  RatingElement = 'guestRating',
  ReadAllReviews = 'readAllReviews',
  ReviewCard = 'reviewCard',
  ReviewLogo = 'reviewLogo',
}
const _exp = /*#__PURE__*/() => ({
  hasHiddenOverflow
}) => hasHiddenOverflow ? 'hidden' : 'visible';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wzhw0uq",
  propsAsIs: false,
  vars: {
    "wzhw0uq-0": [_exp()]
  }
});

/**
 * Action wrapper to track specific element, reuse this if you need interaction as well
 */
const trackReviewClickEvent = (entity: Entity, selectedElement?: SelectedElementType) => trackEvent({
  category: Category.User,
  entity,
  action: Action.Clicked,
  ...(selectedElement ? {
    payload: {
      selectedElement
    }
  } : {})
});
interface Props {
  dataId?: string;
  element: SelectedElementType;
  children: React.ReactNode;
  entity: Entity;
  stopPropagation?: boolean;
  hasHiddenOverflow?: boolean;
}
export const ReviewsTrackClick = ({
  dataId,
  element,
  children,
  entity,
  stopPropagation,
  hasHiddenOverflow = false
}: Props) => {
  const dispatchTeamEvent = useDispatchTeamEvent();
  const onClick: React.MouseEventHandler = useCallback(event => {
    if (stopPropagation) event.stopPropagation();
    dispatchTeamEvent(trackReviewClickEvent(entity, element));
  }, [dispatchTeamEvent, element, stopPropagation]);
  return <Wrapper data-id={dataId} onClick={onClick} role="presentation" hasHiddenOverflow={hasHiddenOverflow}>
      {children}
    </Wrapper>;
};

require("./ReviewsTrackClick.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ReviewsTrackClick.tsx");